import React, { Fragment } from 'react';
import { Checkbox as AntCheckbox, Flex } from 'antd';
import Label from 'common/label/Label';
import cx from 'clsx';
import styles from './Checkbox.module.scss';
import ErrorMessage from 'common/error-message/ErrorMessage';

const Checkbox = ({
  checked = null,
  disabled = false,
  indeterminate,
  defaultChecked,
  error = '',
  label = '',
  name = '',
  style = null,
  className = '',
  labelPosition = 'end',
  labelClassName = '',
  required = false,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
}) => {
  return (
    <Flex vertical gap={5}>
      <Flex gap={10} align="center">
        {label && labelPosition === 'start' && (
          <Label className={labelClassName} required={required} style={{ marginBlockEnd: '0px' }}>
            {label}
          </Label>
        )}
        <div className={styles.checkBoxContainer} onClick={(e) => e.stopPropagation()}>
          <AntCheckbox
            name={name}
            disabled={disabled}
            indeterminate={indeterminate}
            defaultChecked={defaultChecked}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            style={style}
            className={className}
            {...(checked === null ? {} : { checked: checked })}
          />
        </div>
        {label && labelPosition === 'end' && (
          <Label className={labelClassName} required={required} style={{ marginBlockEnd: '0' }}>
            {label}
          </Label>
        )}
      </Flex>
      {error && <ErrorMessage errorMessage={error} />}
    </Flex>
  );
};

export default Checkbox;
